/*
 * Copyright (c) 2026. BrightNight. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */

import {
  DEFAULT_USER_PREFERENCES,
  type PreferencePath,
  type PreferenceValue,
  type StoredUserPreferences,
  type UserPreferences,
} from '@poweralpha/common';
import { createContext, useContext } from 'react';

export interface UserPreferencesContextValue {
  /** Defaults merged with the user's overrides. */
  preferences: UserPreferences;
  /** Only what the user overrode (what `users.preferences` holds). */
  stored: StoredUserPreferences;
  setPreference: <P extends PreferencePath>(path: P, value: PreferenceValue<P>) => void;
  /** Deletes overrides so the paths fall back to their defaults. */
  resetPreferences: (paths: PreferencePath[]) => void;
}

export const UserPreferencesContext = createContext<UserPreferencesContextValue>({
  preferences: DEFAULT_USER_PREFERENCES,
  stored: {},
  setPreference: () => undefined,
  resetPreferences: () => undefined,
});

export const useUserPreferences = () => useContext(UserPreferencesContext);
